export class OptixSettingName {
    public static readonly Currency: string = 'Currency';
    public static readonly CurrencySymbol: string = 'CurrencySymbol';
    public static readonly DefaultHomePage: string = 'DefaultHomePage';
    public static readonly XpasHomeUrl: string = 'XpasHomeUrl';
    public static readonly XpasLiteHomeUrl: string = 'XpasLiteHomeUrl';
    public static readonly ETS: string = 'ETS';
    public static readonly DisplayEnergyFilter: string = 'DisplayEnergyFilter';
    public static readonly BaseInterval: string = 'BaseInterval';
    public static readonly RunningHoursUnitTypes: string = 'RunningHoursUnitTypes';
    public static readonly PemsUnitTypes: string = 'PemsUnitTypes';
    public static readonly PemsTitle: string = 'PemsTitle';
    public static readonly EnergyFilterOptions: string = 'EnergyFilterOptions';
    public static readonly AnalysisPageShowAbsorbedPowerForEquipment: string = 'AnalysisPageShowAbsorbedPowerForEquipment';
    public static readonly UserManualUrl: string = 'UserManualUrl';
    public static readonly EmissionsCo2Label: string = 'CO<sub>2</sub>';
    public static readonly OperatingStatusLevels: string = 'OperatingStatusLevels';
    public static readonly LaePeriodTableTopX: string = 'LaePeriodTableTopX';
    public static readonly DtuCostPerMinute: string = 'DtuCostPerMinute';
    public static readonly StorageCostPerMinute: string = 'StorageCostPerMinute';
    public static readonly ColdFlaring: string = 'ColdFlaring';
    public static readonly EnableChartTypeSwitch: string = 'EnableChartTypeSwitch';
    public static readonly PemsAnalysisFilterGroups: string = 'PemsAnalysisFilterGroups';
    public static readonly HomepageShowTopX: string = 'HomepageShowTopX';
    public static readonly VentReconciliationAllowChangingFigures: string = 'VentReconciliationAllowChangingFigures';
    public static readonly LandingCarouselRotationTimeout: string = 'LandingCarouselRotationTimeout';
    public static readonly IsDemoAsset: string = 'IsDemoAsset';
}